import React, { Component } from 'react';
import Button from '../../components/button';
import styles from './landing.module.scss';
import DirectionButtonRow from '../../components/direction-button-row';
import contentLanding from '../../contentful/landingPage.json';
import contentSector from '../../contentful/sectorPage.json';
import contentStrategy from '../../contentful/strategyPage.json';
import Markdown from '../../components/markdown';
import Map from '../../components/map';
import { Link } from 'react-router-dom';
import safeGa from '../../modules/safeGa';

class LandingPage extends Component {
  componentDidMount() {
    safeGa('set', 'page', '/landing.html');
    safeGa('send', 'pageview');
  }
  render() {
    const props = this.props;
    const introText = contentLanding.content;
    return (
      <div>
        <div className={styles.introContent}>
          <div className={styles.introContentLeft}>
            <h1 className={styles.primaryHeading}>
              State infrastructure strategy 2018
            </h1>
            <div className={styles.introParagraph}>
              <Markdown content={introText} />
            </div>
            <Button
              onClick={() => {
                safeGa('send', {
                  hitType: 'event',
                  eventCategory: 'about',
                  eventAction: 'click',
                  eventLabel: 'About button landing page',
                });
              }}
              type="about"
              link={'/about'}
            >
              <span>About the strategy</span>
            </Button>
            <div className="desktopOnly">
              <Link
                onClick={() => {
                  safeGa('send', {
                    hitType: 'event',
                    eventCategory: 'strategies',
                    eventAction: 'click',
                    eventLabel: 'Headline landing page',
                  });
                }}
                to="/strategies"
              >
                <h2 className={styles.secondaryHeadingMagenta}>
                  Strategic directions
                </h2>
              </Link>
              <p className={styles.pageIntroText}>
                The Strategy sets six cross-sectoral strategic directions, each
                designed to achieve 'more with less' and embed good practice
                across the infrastructure lifecycle.
              </p>
            </div>
          </div>
          <div className={styles.introContentRight}>
            <div className={styles.imageBlock}>
              <img
                src={'/img/report-thumbnail.png'}
                alt="INSW State Infrastructure Strategy Report"
              />
            </div>

            <Button
              onClick={() => {
                safeGa('send', {
                  hitType: 'event',
                  eventCategory: 'pdf',
                  eventAction: 'click',
                  eventLabel: 'Strategy-PDF',
                });
              }}
              type={'report'}
              isExternal
              link="/documents/INSW_2018SIS_BuildingMomentum.pdf"
            >
              Download strategy PDF
            </Button>
            
            <div className={styles.imageBlock} style={{ height: 151 }}>
              <img
                src={'/img/gov-response-thumbnail.png'}
                alt="Government response thumbnail"
              />
            </div>
            <Button
              onClick={() => {
                safeGa('send', {
                  hitType: 'event',
                  eventCategory: 'external-links',
                  eventAction: 'click',
                  eventLabel: 'gov-response',
                });
              }}
              type="govResponse"
              isExternal
              link="https://nsw.gov.au/infrastructurestrategy"
            >
              Read more
            </Button>
          </div>
        </div>
        <div className="mobileOnly">
          <Link
            onClick={() => {
              safeGa('send', {
                hitType: 'event',
                eventCategory: 'strategies',
                eventAction: 'click',
                eventLabel: 'Headline landing page',
              });
            }}
            to="/strategies"
          >
            <h2 className={styles.secondaryHeadingMagenta}>
              <span className={`mobileOnly ${styles.mobileLine} `} />
              <span className={`mobileOnly ${styles.headlineText} `}>
                Strategic<br />directions
              </span>
              <span className={`desktopOnly ${styles.headlineText} `}>
                Strategic directions
              </span>
            </h2>
          </Link>
          <p>
            The Strategy sets six cross-sectoral strategic directions, each
            designed to achieve 'more with less' and embed good practice across
            the infrastructure lifecycle.
          </p>
        </div>
        <DirectionButtonRow
          theme={'theme-magenta'}
          type={'strategies'}
          content={contentStrategy.strategies}
        />
        <Link
          onClick={() => {
            safeGa('send', {
              hitType: 'event',
              eventCategory: 'geographic',
              eventAction: 'click',
              eventLabel: 'Headline landing page',
            });
          }}
          to="/geographic"
        >
          <h2 className={styles.secondaryHeadingGreen}>
            <span className={`mobileOnly ${styles.mobileLine} `} />
            <span className={`mobileOnly ${styles.headlineText} `}>
              Geographic<br />infrastructure<br />directions
            </span>
            <span className={`desktopOnly ${styles.headlineText} `}>
              Geographic infrastructure directions
            </span>
          </h2>
        </Link>
        <p className={styles.pageIntroText}>
          The Strategy recognises that different parts of NSW face different
          opportunities and needs, and sets geographic directions for
          infrastructure planning, investment and policy.
        </p>
        <div className={styles.mapContainer}>
          <Map history={props.history} />
        </div>
        <Link
          onClick={() => {
            safeGa('send', {
              hitType: 'event',
              eventCategory: 'sectors',
              eventAction: 'click',
              eventLabel: 'Headline landing page',
            });
          }}
          to="/sectors"
        >
          <h2 className={styles.secondaryHeadingBlue}>
            <span className={`mobileOnly ${styles.mobileLine} `} />
            <span className={styles.headlineText}>Sectors</span>
          </h2>
        </Link>
        <p className={styles.pageIntroText}>
          Building on these strategic and geographic directions, the Strategy
          outlines policy and investment options across the key infrastructure
          sectors.
        </p>

        <DirectionButtonRow
          theme={'theme-blue'}
          type={'sectors'}
          content={contentSector.sectors}
          titleCentered={true}
          addMarginForIframe={true}
        />
      </div>
    );
  }
}
export default LandingPage;



// WEBPACK FOOTER //
// ./src/pages/landing/landing.js